<div class="standard-toggle-switch-container" [class.standard-toggle-switch-disabled]="disabled">
    <label [for]="id" class="standard-toggle-switch-caption">
        {{ label }}
        @if (infoText) {
            <span [ngbTooltip]="infoText" placement="left"><i class="fas fa-info-circle fa-lg ms-1"></i></span>
        }
    </label>

    <div class="standard-toggle-switch" [class.standard-toggle-switch-disabled]="disabled">
        @if (rectangularSwitch) {
            <label class="standard-toggle-switch-position">
                <input type="checkbox" [disabled]="disabled" [(ngModel)]="checked" (change)="onChange()" (blur)="onTouchedFn()" />
                <span class="standard-toggle-switch-slider"></span>
            </label>
        }
        <div class="d-flex flex-row pb-2">
            <small class="form-text text-muted pe-2" [class.standard-toggle-switch-dotter-element]="notToggledTooltip" [ngbTooltip]="notToggledTooltip" [disableTooltip]="!notToggledTooltip" placement="auto"> {{ notToggledLabel }}</small>

            @if (!rectangularSwitch) {
                <label class="standard-toggle-switch-position">
                    <input type="checkbox" [disabled]="disabled" [(ngModel)]="checked" (change)="onChange()" (blur)="onTouchedFn()" />
                    <span class="standard-toggle-switch-slider round"></span>
                </label>
            }

            <small class="form-text text-muted ps-2" [class.standard-toggle-switch-dotter-element]="toggledTooltip" [ngbTooltip]="toggledTooltip" [disableTooltip]="!toggledTooltip" placement="auto"> {{ toggledLabel }}</small>
        </div>
    </div>

    @if (hint?.length) {
        <small class="form-text text-muted d-block mt-1"><i class="far fa-hand-point-right"></i>{{ hint }}</small>
    }
</div>
